import { render, staticRenderFns } from "./ExcluirComprovante.vue?vue&type=template&id=333ceec6&"
import script from "./ExcluirComprovante.vue?vue&type=script&lang=ts&"
export * from "./ExcluirComprovante.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports